import { TicketHeaderProps } from "./types";

function TicketHeader(props: TicketHeaderProps) {
  return (
    <div className="ticketCard_header">
      <div className="ticketCard_headerContent">
        <h2
          className="ticketCard_headerContent--title"
          style={
            props.ticketDisplayColour
              ? ({ "--ticketCardTitleColor": props.ticketDisplayColour } as React.CSSProperties)
              : {}
          }
          title={props.title}>
          {props.title}
        </h2>
      </div>
    </div>
  );
}

export default TicketHeader;
